var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('offer-page',{key:_vm.componentKey,attrs:{"before-list-route":_vm.beforeListRoute}})
}
var staticRenderFns = []

export { render, staticRenderFns }